<div class="pb-2">
    <div class="form-group" [class.has-error]="showError">
        <label *ngIf="to.label && to.hideLabel !== true" [attr.for]="id">
            {{ to.label }}
            <span *ngIf="to.required && to.hideRequiredMarker !== true" class="k-required">*</span>
        </label>
        <kendo-datetimepicker [formControl]="formControl" [formlyAttributes]="field" [class.k-state-invalid]="showError"
            [class]="to.className">
        </kendo-datetimepicker>
        <small *ngIf="to.description" class="form-text text-muted">{{ to.description }}</small>
        <div *ngIf="showError && to.hideLabel !== true" class="k-field-info k-required" [style.top]="0">
            <formly-validation-message [field]="field"></formly-validation-message>
        </div>
    </div>
</div>